import type { ProgramUser } from '../../interfaces/CamProgramming.interface';

/** Whether the signed-in user wrote this review and may edit or remove it. */
export const isReviewAuthor = (
	review: { reviewer?: { id: string } | null },
	userId: string | undefined | null
) => !!userId && review.reviewer?.id === userId;

/** How to address whoever wrote an entry, falling back as fields run out. */
export const authorName = (
	user: ProgramUser | null,
	fallback = 'Unknown author'
) => user?.full_name || user?.email || fallback;

export const PROGRAM_FILENAME_PLACEHOLDER =
	'Enter the name of the program in Fusion 360, or Keyence filename';

/** Part name plus program filename when the two differ or filename is set. */
export const programPartLabel = (
	partName: string,
	filename?: string | null
) => {
	const part = partName.trim() || 'Program';
	const file = filename?.trim();
	if (!file || file === part) {
		return part;
	}
	return `${part} — ${file}`;
};
